import React, { useEffect, useRef } from "react";
import Chart from "chart.js";

Chart.elements.Rectangle.prototype.draw = function () {
  const ctx = this._chart.ctx;
  const vm = this._view;
  let left, right, top, bottom, borderWidth;

  borderWidth = vm.borderWidth;

  if (!vm.horizontal) {
    left = vm.x - vm.width / 2;
    right = vm.x + vm.width / 2;
    top = vm.y;
    bottom = vm.base;
  } else {
    left = vm.base;
    right = vm.x;
    top = vm.y - vm.height / 2;
    bottom = vm.y + vm.height / 2;
  }

  ctx.beginPath();
  ctx.fillStyle = vm.backgroundColor;
  ctx.strokeStyle = vm.borderColor;
  ctx.lineWidth = borderWidth;

  ctx.rect(left, top, right - left, bottom - top);
  ctx.fill();
  if (borderWidth) {
    ctx.stroke();
  }
};

const preparePyramidData = (header, masculinoPerc, femininoPerc) => {
  if (!header || !masculinoPerc || !femininoPerc) return;
  return [header, masculinoPerc, femininoPerc];
};


const initializeChart = (dataset) => {
  const maxValue = Math.max(
    Math.max(...dataset[1].map(Math.abs)),
    Math.max(...dataset[2].map(Math.abs))
  ) + 4;

  if (dataset[0][0] !== "" || dataset[0][1] !== "") {
    for (let i = 0; i < 2; i++) {
      dataset[1].unshift(null);
      dataset[2].unshift(null);
      dataset[0].unshift("");

      dataset[1].push(null);
      dataset[2].push(null);
      dataset[0].push("");
    }
  }
  const config = {
    type: "horizontalBar",
    data: {
      labels: dataset[0],
      datasets: [
        {
          label: "Homens %",
          backgroundColor: 'rgba(54, 162, 235, 0.7)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 1,
          data: dataset[1],
        },
        {
          label: "Mulheres %",
          backgroundColor: 'rgba(255, 99, 132, 0.7)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 1,
          data: dataset[2],
        },
      ],
    },
    options: {
      layout: {
        padding: {
          top: 10,
          bottom: 10
        },
      },
      maintainAspectRatio: false,
      responsive: true,
      tooltips: {
        mode: "index",
        intersect: false,
        filter: (tooltipItem, data) =>
          tooltipItem.index >= 2 && tooltipItem.index < data.labels.length - 2,
        callbacks: {
          label: (tooltipItem, data) => {
            const datasetLabel =
              data.datasets[tooltipItem.datasetIndex].label || "";
            const value = tooltipItem.xLabel;
            return `${datasetLabel}: ${Math.abs(value).toFixed(1)}`;
          },
        },
      },
      hover: {
        mode: "nearest",
        intersect: true,
      },
      legend: {
        display: true,
        position: "bottom",
      },
      scales: {
        xAxes: [
          {
            type: "linear",
            stacked: true,
            offset: true,
            ticks: {
              min: -maxValue,
              max: maxValue,
              autoSkip: false,
              display: false,
            },
            gridLines: {
              display: false,
            },
            scaleLabel: {
              display: false,
            },
          },
        ],
        yAxes: [
          {
            stacked: true,
            scaleLabel: {
              display: true,
              labelString: "Faixa Etária",
            },
            gridLines: {
              display: true,
            },
            categoryPercentage: 0.9,
            barPercentage: 0.9,
          },
        ],
      },
      plugins: {
        datalabels: {
          display: false,
        },
      },
      animation: {
        onComplete: function () {
          const ctx = this.chart.ctx;
          const datasets = this.chart.data.datasets;

          datasets.forEach((dataSet, datasetIndex) => {
            const meta = this.chart.getDatasetMeta(datasetIndex);

            if (meta.hidden) return;

            meta.data.forEach((bar, index) => {
              const value = dataSet.data[index];
              if (value == null || value === 0) return;

              const isMale = dataSet.label === 'Homens %';
              const offset = -3;

              ctx.save();
              ctx.font = 'bold 9px Arial';
              ctx.fillStyle = '#4d4d4d';
              ctx.textAlign = isMale ? 'right' : 'left';
              ctx.textBaseline = 'middle';

              const x = bar._model.x + (isMale ? offset : -offset);
              const y = bar._model.y;

              if (x > 0 && x < ctx.canvas.width) {
                ctx.fillText(Math.abs(value).toFixed(1), x, y);
              }
              ctx.restore();
            });
          });
        },
      },
    },
  };

  if (window.myBar) {
    window.myBar.destroy();
  }

  const ctx = document.getElementById("bar-chart").getContext("2d");
  window.myBar = new Chart(ctx, config);
};

const PyramidChart = ({ header, masculinoPerc, femininoPerc }) => {
  const chartContainerRef = useRef(null);

  useEffect(() => {
    if (!header || !masculinoPerc || !femininoPerc) return;
    const datasets = preparePyramidData(header, masculinoPerc, femininoPerc);
    initializeChart(datasets);
  }, [header, masculinoPerc, femininoPerc]);

  return (
    <div className="relative flex flex-col max-h-[26rem] min-w-0 break-words bg-white w-full border rounded-lg shadow-lg" ref={chartContainerRef}>
      <div className="p-4 flex-auto">
        <div className="relative h-96">
          <canvas id="bar-chart"></canvas>
        </div>
      </div>
    </div>
  );
};
export default PyramidChart;